import cx from 'classnames';
import React from 'react';
import { useId } from '../index.js';
/**
 * A component that wraps an input of type=file with the required markup necessary to format the
 * file input button and label for use in a FormItem component.
 */
export const FormInputFileUpload = ({ accept, className, disabled, id, inputRef, label = 'Select File', maxFileSize, maxFiles, multiple, name, onChange, required, variant, ...rest }) => {
    const uuid = useId();
    const uid = id || uuid;
    const htmlName = name || `file_input_${uid}`;
    const htmlId = id || `${htmlName}_upload`;
    const tdsBtnVariant = variant || 'tertiary';
    return (React.createElement("div", { className: "tds-form-input" },
        React.createElement("input", { accept: accept, className: "tds-form-input-file-upload", "data-max-file-size": maxFileSize, "data-max-files": maxFiles, disabled: disabled, id: htmlId, multiple: multiple, name: htmlName, onChange: onChange, ref: inputRef, required: required, type: "file", ...rest }),
        React.createElement("label", { className: cx('tds-btn', `tds-btn--${tdsBtnVariant}`, className), htmlFor: htmlId },
            React.createElement("span", null, label))));
};
